const information_tabs = () => {
    if ( $('.information-tabs-module').length ) {
        $('.information-tabs-module').each(function() {
            let windowWidth = $(window).width();
            let $thisModule = $(this);
            let $categoryTabs = $thisModule.find('.category-tabs');
            let $tabCategories = $thisModule.find('.tab-categories');
            let initialSlide = 0;

            if ($thisModule.find('.tab-category').length > 1) {
                initialSlide = 1;
            }

            // category button clicks (mobile)
            $thisModule.find('.category-button').on('click', function() {
                if ( !$(this).hasClass('active') ) {
                    let categoryIndex = $(this).data('category-index');

                    $thisModule.find('.category-button.active').removeClass('active');
                    $(this).addClass('active');
                    $thisModule.find('.tab-category.active').removeClass('active');
                    $thisModule.find('.tab-category[data-category-index="' + categoryIndex + '"]').addClass('active');
                    $categoryTabs.hide();
                    let $newCategory = $thisModule.find('.category-tabs[data-category-index="' + categoryIndex + '"]');
                    $newCategory.fadeIn();

                    // update mobile category buttons progress bar
                    let $categoryButtonsWrapper = $thisModule.find('.category-buttons-wrapper');
                    let $activeButton = $thisModule.find('.category-button.active');
                    updateCategoryButtonsProgressBar($categoryButtonsWrapper, $activeButton);

                    // update desktop progress bar for the new category
                    let $activeTab = $newCategory.find('.info-tab.active');
                    if ($activeTab.length) {
                        updateDesktopProgressBar($newCategory, $activeTab);
                    }

                    // navigate the slick carousel to the correct slide on mobile
                    if ($(window).width() < 992) {
                        $tabCategories.slick('slickGoTo', categoryIndex);
                    }
                }
            });

            function updateCategoryButtonsProgressBar($wrapper, $activeButton) {
                let $allButtons = $wrapper.find('.category-button');
                // require at least 2 buttons to show a progress
                if ($allButtons.length < 2) {
                    $wrapper.find('.category-progress__bar').css({ width: 0, left: 0 });
                    return;
                }

                let $firstButton = $allButtons.first();
                let $progressContainer = $wrapper.find('.category-progress');
                if (!$progressContainer.find('.category-progress__track').length) {
                    $progressContainer.prepend('<div class="category-progress__track"></div>');
                }
                let $progressBar = $progressContainer.find('.category-progress__bar');
                let $progressTrack = $progressContainer.find('.category-progress__track');

                // fallback if offsets are not available
                let progressOffset = $progressContainer.offset() ? $progressContainer.offset().left : $wrapper.offset().left;
                let firstOffset = $firstButton.offset().left;
                let activeOffset = $activeButton.offset().left;
                let activeWidth = $activeButton.outerWidth();

                // calculate left position (from the progress container's left) and width in pixels
                let progressLeft = Math.max(0, firstOffset - progressOffset);
                let progressWidth = Math.max(0, (activeOffset - firstOffset) + activeWidth);

                // calculate grey track from first button to last button
                let $lastButton = $allButtons.last();
                let lastOffset = $lastButton.offset().left;
                let lastWidth = $lastButton.outerWidth();
                let trackLeft = Math.max(0, firstOffset - progressOffset);
                let trackWidth = Math.max(0, (lastOffset + lastWidth) - firstOffset);

                if (!isFinite(progressLeft) || !isFinite(progressWidth)) {
                    $progressBar.css({ width: 0, left: 0 });
                    return;
                }

                // apply track (grey) then bar (blue)
                $progressTrack.css({
                    left: trackLeft + 'px',
                    width: trackWidth + 'px'
                });

                $progressBar.css({
                    left: progressLeft + 'px',
                    width: progressWidth + 'px'
                });
            }

            

            // recalculate progress positions on resize change
            $(window).on('resize orientationchange', function() {
                $thisModule.find('.category-buttons-wrapper').each(function() {
                    let $wrapper = $(this);
                    let $activeButton = $wrapper.find('.category-button.active');
                    if ($activeButton.length) {
                        updateCategoryButtonsProgressBar($wrapper, $activeButton);
                    }
                });
            });

            $tabCategories.slick({
                mobileFirst: true,
                initialSlide: initialSlide,
                autoplay: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
                arrows: true,
                prevArrow: $thisModule.find('.info-tab-arrow.left'),
                nextArrow: $thisModule.find('.info-tab-arrow.right'),
                dots: false,
                cssEase: 'linear',
                responsive: [{
                    breakpoint: 992,
                    settings: "unslick",
                }]
            });

             // On before slide change
            $tabCategories.on('beforeChange', function(event, slick, currentSlide, nextSlide){
                // sync active category button with the slide
                $thisModule.find('.category-button.active').removeClass('active');
                $thisModule.find('.category-button[data-category-index="' + nextSlide + '"]').addClass('active');
                let $categoryButtonsWrapper = $thisModule.find('.category-buttons-wrapper');
                let $activeButton = $thisModule.find('.category-button[data-category-index="' + nextSlide + '"]');
                updateCategoryButtonsProgressBar($categoryButtonsWrapper, $activeButton);

                if ($thisModule.find('.tab-category').length > 1) {
                    // Only hide if the next tab is different
                    const $nextTab = $thisModule.find('.category-tabs[data-category-index="' + nextSlide + '"]');
                    if (!$nextTab.is(':visible')) {
                        $categoryTabs.filter(':visible').hide();
                        $nextTab.fadeIn();
                    }
                }

                if (nextSlide == 0) {
                    $thisModule.find('.info-tabs-bg-image').animate({
                        left: '0%',
                    }, 500, 'linear');
                } else if (nextSlide == 1) {
                    $thisModule.find('.info-tabs-bg-image').animate({
                        left: '-39%',
                    }, 500, 'linear');
                } else if (nextSlide == 2) {
                    $thisModule.find('.info-tabs-bg-image').animate({
                        left: '-94%',
                    }, 500, 'linear');
                }
            });
            
            // tab-category clicks (desktop)
            $thisModule.find('.tab-category').on('click', function() {
                if ( !$(this).hasClass('active') ) {
                    let categoryIndex = $(this).data('category-index');

                    $thisModule.find('.tab-category.active').removeClass('active');
                    $(this).addClass('active');
                    $thisModule.find('.category-button.active').removeClass('active');
                    $thisModule.find('.category-button[data-category-index="' + categoryIndex + '"]').addClass('active');
                    $categoryTabs.hide();
                    let $newCategory = $thisModule.find('.category-tabs[data-category-index="' + categoryIndex + '"]');
                    $newCategory.fadeIn();

                    // update mobile category buttons progress bar
                    let $categoryButtonsWrapper = $thisModule.find('.category-buttons-wrapper');
                    let $activeButton = $thisModule.find('.category-button.active');
                    updateCategoryButtonsProgressBar($categoryButtonsWrapper, $activeButton);

                    // update desktop progress bar for the new category
                    let $activeTab = $newCategory.find('.info-tab.active');
                    if ($activeTab.length) {
                        updateDesktopProgressBar($newCategory, $activeTab);
                    }
                }
            });

            $thisModule.find('.info-tab').on('click', function() {
                let $this = $(this);
                let tabIndex = $this.data('tab-index');
                let $categoryWrapper = $(this).closest('.category-tabs');

                $categoryWrapper.find('.info-tab').removeClass('active');
                $this.addClass('active');
                $categoryWrapper.find('.info-tab-content').hide();
                $categoryWrapper.find('.info-tab-content[data-tab-index="' + tabIndex + '"]').fadeIn();

                // update progress bar on tab click
                updateDesktopProgressBar($categoryWrapper, $this);
            });

            function updateDesktopProgressBar($categoryWrapper, $activeTab) {
                let $infoTabs = $categoryWrapper.find('.info-tabs');
                let $progressBar = $categoryWrapper.find('.info-tabs-progress__bar');
                
                if ($infoTabs.length && $progressBar.length) {
                    let $allTabs = $infoTabs.find('.info-tab');
                    let firstTab = $allTabs.first();
                    let activeTabPosition = $activeTab.position();
                    let firstTabPosition = firstTab.position();
                    let activeTabWidth = $activeTab.outerWidth();
                    
                    // Calculate the distance from the first tab to the end of the active tab
                    let progressWidth = (activeTabPosition.left - firstTabPosition.left) + activeTabWidth;
                    $progressBar.css('width', progressWidth + 'px');
                }
            }

            $thisModule.find('.info-tabs-select').select2({
                selectionCssClass: 'custom-info-tab-select',
                dropdownCssClass: 'custom-info-tab-dropdown'
            });

            $thisModule.find('.info-tabs-select').on('change', function() {
                let $categoryTabs = $(this).closest('.category-tabs');
                let tabIndex = $(this).val();

                $categoryTabs.find('.info-tab-content').hide();
                $categoryTabs.find('.info-tab-content[data-tab-index="' + tabIndex + '"]').fadeIn();
            });

            // set initial progress bar position for first category
            let $firstVisibleCategory = $thisModule.find('.category-tabs:visible');
            if ($firstVisibleCategory.length) {
                let $activeTab = $firstVisibleCategory.find('.info-tab.active');
                if ($activeTab.length) {
                    updateDesktopProgressBar($firstVisibleCategory, $activeTab);
                }
            }

            // Initialize mobile category buttons progress bar
            let $categoryButtonsWrapper = $thisModule.find('.category-buttons-wrapper');
            let $activeButton = $categoryButtonsWrapper.find('.category-button.active');
            if ($activeButton.length) {
                updateCategoryButtonsProgressBar($categoryButtonsWrapper, $activeButton);
            }
        });
    }
};

export default information_tabs;